import type { AsyncStorageLike, StorageAdapter } from './types';

export async function getJsonFromAdapter<T>(adapter: StorageAdapter, key: string): Promise<T | null> {
	const raw = await adapter.getItem(key);
	if (raw === null) {
		return null;
	}

	try {
		return JSON.parse(raw) as T;
	} catch {
		return null;
	}
}

export async function setJsonOnAdapter(adapter: StorageAdapter, key: string, value: unknown): Promise<void> {
	await adapter.setItem(key, JSON.stringify(value));
}

export function createJsonMethods(getAdapter: () => StorageAdapter): Pick<AsyncStorageLike, 'getJson' | 'setJson'> {
	return {
		getJson<T>(key: string): Promise<T | null> {
			return getJsonFromAdapter<T>(getAdapter(), key);
		},
		setJson(key: string, value: unknown): Promise<void> {
			return setJsonOnAdapter(getAdapter(), key, value);
		},
	};
}
